import * as yup from "yup";

export const validationSchema = yup.object({
  firstName: yup.string().required("First Name is required."),
  lastName: yup.string().required("Last Name is required."),
  email: yup
    .string()
    .required("Email is required.")
    .email("Please enter a valid email address"),
  contact: yup
    .number()
    .required("Contact Number is required.")
    .min(11, "Invalid Number"),
  password: yup.string().required("Password is required.").min(6),
  confirmPassword: yup
    .string()
    .required("Confirm password is required.")
    .min(5)
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});
